<template>
<div class="product-detail-page">
	<!-- 顶部导航栏 -->
	<div class="custom-nav-bar">
		<button class="nav-back-btn" @click="back()">
			<i class="van-icon van-icon-arrow-left"></i>
		</button>
		<div class="nav-title">{{ $t('profile.productDetail') }}</div>
		<button class="nav-service-btn" @click="toService">
			<i class="van-icon">
				<img class="van-icon__image" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAA4BJREFUWEfFlmnIpnMUxn/XF75Z840SgxAa2xiRJRnLkMlS82WSqcE09hBlnQxNQsaSyZJMmozsJNuMhvggGmQJKVtRJqbIJ5eux7nf7nk9z/vc91OaU/+e5f6fc677LNc5YhuLtrF/egGwfShwJHAIcHCdn4GP62yS9Gyfl+oEwPZuwBXAlcD2YxxsAO6W9EIXIGMB2F5ajvcGvgFWA1/X+QrYBdgHmAUcBSwux2uAFZI+nwnIjADK+f1l4AHgNkk/5bftHYH9gM2SAmggtk8DrgJOBD4C5jc6w4CMBGB7PvBiKS2UtNb2/sAlwEn11o3NP4EvgbWSVhaQO4BrgbeAMyX90RmA7YOAl4E9gBuB24Gby/kOY3L7LrAyNWB7HXAO8LSkc/sAWAFcBzwCXA88BiS0fWQJ8BLwanXLsZLemW5gaApsp3BSVGm1J4DD+nhu3b2hvi8H7pV02VgAts8C0svPAd8Bl07ovFGbC7wH5KXmSfq+be8/EbD9OLAIOBl4rafz5Hx6rp8EUjcp6oeBN1PQjd0pALbTz6n6o+thcndKTwDhgLTmNdP0Qk7Ht/7bSdLv+d0GcH4VW0+fU9fTiscACXGKLUBGyS2S0lVbAbipWm0SAJuB5ZLuKQ64PHT8fwLIAPqwdTZICoiB2J5dz3pFICFJFEbJRiD8PnAs6e+ZQmU7zLjviDtDUzATgCmFrvmxvQpY1gdAmOuhEQonSEoldxbbd9ZQis6WasVGfzBbphfhnsC3deOvotCQUmRnSb919v5vHYTGLyid04vQ5gHrJJ3X2BpGROnlp4A5wOt1cYGkMGNnsf0MsAB4VNJi2xcDtwKzJf0wEkDbg+0HgYuAsTVg+wDgQElhw0RgfZwBGUKf2P4iRCfp6raPLhvRL7WGzZX0Wct4IrKpjIV+TwWOC9fb3qu2pwHw2i0yX/L2n/YCUA7TnnMkTY1k2/nvDGBXIC2aZeSVup/8r5e0xvbuwPPAG5KyoGwlYyPQ3LadbTgg0l4jxXYKeZGkjba3q8Vmi6Szhyl1BtACMqu9A45CYjtrW0Z5tqq08dAu6g2gBSS8sRB4uxksFf7M/zzLKnZfjqQfRwGdCIDtbEgftIzeBRwOHAH8WqvYqqZoZ0rZpAAy29NmjaT1svW8LymfnWUiABXq0HZCvVrShZ09TtoFkzoYpzdxBMYZ7vr8HyNeRjAaHC/gAAAAElFTkSuQmCC">
			</i>
		</button>
	</div>

	<!-- 详情区域（金色边框） -->
	<div class="detail-section">
		<div class="detail-header">
			<span class="detail-icon">📄</span>
			<span class="detail-title">{{ $t('profile.beautyDetail') }}</span>
		</div>
		<hr class="detail-divider"/>
		<div class="detail-content">
			<p class="detail-item">
				<span class="label">{{ $t('profile.nickname') }}:</span>
				<span class="value">{{ xuanfeidata.xuanfei_name || '-' }}</span>
			</p>
			<p class="detail-item">
				<span class="label">{{$t('home.sg')}}:</span>
				<span class="value">{{ xuanfeidata.sg || '-' }}cm</span>
				<span class="label"> {{$t('home.xw')}}:</span>
				<span class="value">{{ xuanfeidata.xw || '-' }}</span>
			</p>
			<p class="detail-item">
				<span class="label">{{ $t('profile.type') }}:</span>
				<span class="value">{{ getTypeText() }}</span>
			</p>
			<p class="detail-item">
				<span class="label">{{$t('home.star')}}:</span>
				<span class="value">
					<span v-for="(numa,indexs) in xuanfeidata.star" :key="indexs">⭐</span>
					<span v-if="!xuanfeidata.star || xuanfeidata.star.length === 0">-</span>
				</span>
			</p>
			<p class="detail-item">
				<span class="label">{{$t('home.diqu')}}:</span>
				<span class="value">{{ xuanfeidata.class_name || '-' }}</span>
			</p>
			<p class="detail-item">
				<span class="label">{{$t('choose.move')}}:</span>
				<span class="value">{{$t('possible')}}</span>
			</p>
			<p class="detail-item">
				<span class="label">{{ $t('profile.serviceProject') }}:</span>
				<span class="value">{{ getServiceProject() }}</span>
			</p>
		</div>
		<hr class="detail-divider">
		<div class="detail-stats">
			<div class="stat-item">
				<span class="stat-icon">👁️</span>
				<div class="stat-content">
					<div class="stat-value">{{ formatNumber(xuanfeidata.views || 0) }}</div>
					<div class="stat-label">{{ $t('profile.views') }}</div>
				</div>
			</div>
			<div class="stat-item">
				<span class="stat-icon">👍</span>
				<div class="stat-content">
					<div class="stat-value">{{ formatNumber(xuanfeidata.likes || 0) }}</div>
					<div class="stat-label">{{ $t('profile.likes') }}</div>
				</div>
			</div>
		</div>
		<hr class="detail-divider"/>
	</div>
	<hr class="detail-divider"/>
	<!-- 主图区域 -->
	<div class="main-image-section">
		<img :src="currentMainImage" 
			alt="主图" 
			class="main-image"
		/>
	</div>

	<!-- 缩略图滑动区域 -->
	<div class="thumbnail-section">
		<div class="thumbnail-container" ref="thumbnailContainer">
			<div 
				v-for="(img, index) in xuanfeidata.img_url || []" 
				:key="index"
				class="thumbnail-item"
				:class="{ active: currentImageIndex === index }"
				@click="selectImage(index)"
			>
				<img :src="img" alt="缩略图" />
			</div>
		</div>
	</div>

	<!-- 立即预约按钮 -->
	<button class="book-button" @click="handleBook">
		<span class="book-icon">🛒</span>
		<span class="book-text">{{ $t('profile.bookNow') }}</span>
	</button>

	<!-- 预约提示弹窗 -->
	<van-popup
		v-model="showBookDialog"
		:close-on-click-overlay="false"
		:style="{ width: '85%', borderRadius: '12px' }"
		class="book-dialog"
	>
		<div class="dialog-content">
			<div class="dialog-icon">⚠️</div>
			<div class="dialog-title">{{ $t('profile.warmTip') }}</div>
			<div class="dialog-message">{{ $t('profile.contactService') }}</div>
			<button class="dialog-button" @click="showBookDialog = false">{{ $t('profile.gotIt') }}</button>
		</div>
	</van-popup>

	<!-- 原有的下注功能弹窗（保留） -->
	<van-popup
		v-model="show"
		closeable
		close-icon="close"
		get-container="#app"
		:style="{ height:'88%',width:'90%' }"
	>
		<Game :pkey="xuanfeidata.lottery.key" :pid="xuanfeidata.lottery.id" :ppic="xuanfeidata.img_url[0]"/>
	</van-popup>
</div>
</template>

<script>
import Game from '../../common/Game'

export default {
	components: {
		Game
	},
	data() {
		return {
			xuanfeidata: {},
			userInfo: {},
			show: false,
			showBookDialog: false,
			currentImageIndex: 0,
			nowPlayVideoUrl: '',
			cover: "",
			player: null
		};
	},
	computed: {
		currentMainImage() {
			if (this.xuanfeidata.img_url && this.xuanfeidata.img_url.length > 0) {
				return this.xuanfeidata.img_url[this.currentImageIndex] || this.xuanfeidata.img_url[0];
			}
			return '';
		}
	},
	methods: {
		back() {
			return window.history.back();
		},
		toService() {
			if (this.$store.getters.getBaseInfo.iskefu == 1) {
				this.$router.push("ServiceOnline");
			} else {
				this.$toast.fail(this.$t('common.noallow'));
			}
		},
		getxuanfeidata() {
			this.$http({
				method: 'get',
				url: 'xuanfeidata',
				data: { id: this.$route.query.id }
			}).then(res => {
				this.xuanfeidata = res.data || {};
				this.cover = res.data.cover;
			});
		},
		getUserInfo() {
			this.$http({
				method: 'get',
				url: 'user_info'
			}).then(res => {
				if (res.code === 200) {
					this.userInfo = res.data || {};
				}
			}).catch(() => {
				// 获取用户信息失败
			});
		},
		selectImage(index) {
			this.currentImageIndex = index;
		},
		handleBook() {
			if (!localStorage.getItem('token')) {
				this.$router.push({ path: '/Login' });
				return;
			}
			// 判断用户是否为VIP
			if (this.userInfo.is_vip != 1) {
				// 不是VIP，显示提示弹窗
				this.showBookDialog = true;
			} else {
				// 是VIP：不再请求 get_current_order，也不再创建新订单，直接进入认证类型选择页
				this.$router.push({ path: '/CertificationTypeSelect' });
			}
		},
		getTypeText() {
			if (!this.xuanfeidata.tags_arr || this.xuanfeidata.tags_arr.length === 0) {
				return '-';
			}
			return this.xuanfeidata.tags_arr.join('/');
		},
		formatNumber(num) {
			if (num >= 1000) {
				return (num / 1000).toFixed(2) + 'k';
			}
			return num.toString();
		},
		getServiceProject() {
			// 判断用户是否为VIP
			// if (this.userInfo.is_vip == 1) {
			// 	// 是VIP，显示实际服务项目（可以从xuanfeidata中获取，或显示默认内容）
			// 	return this.xuanfeidata.service_project || this.xuanfeidata.service || '详细服务内容';
			// } else {
				// 不是VIP，显示"激活可见"
				return this.$t('profile.activateVisible');
			// }
		}
	},
	created() {
		if (!localStorage.getItem('token')) {
			this.$router.push({ path: '/Login' });
		}
		this.getxuanfeidata();
		this.getUserInfo();
	},
	destroyed() {
		if (this.player) {
			this.player.dispose();
		}
	}
};
</script>

<style scoped>
.product-detail-page {
	background: #000;
	min-height: 100vh;
	color: #fff;
}

/* 导航栏 */
.custom-nav-bar {
	position: relative;
	z-index: 999;
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 100px;
	padding: 0 16px;
	background: url(/img/header.svg) no-repeat 50%/100%;
	border-bottom: 1px solid rgba(255, 255, 255, 0.1);
	box-sizing: border-box;
	height: 3rem;
}

.nav-back-btn {
	background: none;
	border: none;
	padding: 8px;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 0 0 auto;
}

.nav-back-btn .van-icon {
	color: #fff;
	font-size: 30px;
}

.nav-title {
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
	color: #fff;
	font-size: 30px;
	font-weight: 600;
	white-space: nowrap;
}

.nav-service-btn {
	background: none;
	border: none;
	padding: 8px;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 0 0 auto;
}

.nav-service-btn .van-icon {
	color: #fff;
	font-size: 35px;
}

.nav-service-btn .van-icon__image {
	width: 35px;
	height: 35px;
}

/* 详情区域 */
.detail-section {
	margin: 40px 16px;
	padding: 50px 40px 25px 40px;
	width: calc(100% - 32px);
	background: rgba(0, 0, 0, 0.8);
	border: 3px solid #ec4899;
	border-radius: 16px;
	min-height: 60vh;
	box-sizing: border-box;
}

.detail-header {
	display: flex;
	align-items: center;
	margin-bottom: 40px;
	font-size: 32px;
	font-weight: bold;
	color: #ec4899;
}

.detail-icon {
	font-size: 38px;
	margin-right: 16px;
}

.detail-title {
	color: #ec4899;
	font-size: 32px;
	margin-top: 5px;
}

.detail-content {
	margin-bottom: 40px;
}

.detail-item {
	margin: 28px 0;
	font-size: 28px;
	line-height: 1.5;
}

.detail-item .label {
	color: #ec4899;
	margin-right: 16px;
	font-size: 28px;
	font-weight: 600;
}

.detail-item .value {
	color: #fff;
	font-size: 28px;
}

.detail-divider {
	border: none;
	border-top: 2px dashed rgba(212, 175, 55, 0.3);
	margin: 40px 0;
}

.detail-stats {
	display: flex;
	justify-content: space-around;
	align-items: center;
	padding-top: 30px;
}

.stat-item {
	display: flex;
	align-items: center;
	gap: 20px;
}

.stat-icon {
	font-size: 42px;
}

.stat-content {
	display: flex;
	flex-direction: column;
}

.stat-value {
	font-size: 36px;
	font-weight: bold;
	color: #ec4899;
}

.stat-label {
	font-size: 24px;
	color: rgba(255, 255, 255, 0.7);
	margin-top: 8px;
}

/* 主图区域 */
.main-image-section {
	width: 100%;
	height: 50vh;
	overflow: hidden;
	background: #000;
}

.main-image {
	width: 95%;
	height: 100%;
	object-fit: cover;
	border-radius: 5px;
}

/* 缩略图区域 */
.thumbnail-section {
	padding: 20px 16px;
	background: rgba(0, 0, 0, 0.6);
	padding-bottom: 100px; /* 为按钮留出空间，不遮挡图片 */
}

.thumbnail-container {
	display: flex;
	gap: 20px;
	overflow-x: auto;
	scroll-snap-type: x mandatory;
	-webkit-overflow-scrolling: touch;
	padding-bottom: 8px;
}

.thumbnail-container::-webkit-scrollbar {
	height: 6px;
}

.thumbnail-container::-webkit-scrollbar-thumb {
	background: #ec4899;
	border-radius: 3px;
}

.thumbnail-item {
	flex: 0 0 20%;
	min-width: 70px;
	width: 30%;
	height: 150px;
	border-radius: 10px;
	overflow: hidden;
	border: 3px solid #666;
	scroll-snap-align: start;
	cursor: pointer;
	transition: all 0.3s;
	box-sizing: border-box;
}

.thumbnail-item.active {
	border-color: #fff;
	box-shadow: 0 0 15px rgba(255, 255, 255, 0.8);
	transform: scale(1.05);
}

.thumbnail-item img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

/* 预约按钮 */
.book-button {
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	width: 100%;
	height: 80px;
	background: linear-gradient(90deg,#df35ad,#4f1db5);
	border: none;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 16px;
	font-size: 24px;
	font-weight: bold;
	color: #ffffff;
	cursor: pointer;
	z-index: 100;
	box-shadow: 0 -2px 15px rgba(0, 0, 0, 0.4);
}

.book-icon {
	font-size: 28px;
}

.book-text {
	color: #ffffff;
	font-size: 30px;
	font-weight: bold;
}

/* 预约提示弹窗 */
.book-dialog {
	background: rgba(0, 0, 0, 0.9) !important;
	border: 2px solid #ec4899 !important;
}

.dialog-content {
	padding: 60px 60px;
	text-align: center;
	background: rgba(0, 0, 0, 0.95);
	border-radius: 12px;
}

.dialog-icon {
	font-size: 60px;
	margin-bottom: 20px;
}

.dialog-title {
	font-size: 28px;
	font-weight: bold;
	color: #fff;
	margin-bottom: 20px;
}

.dialog-message {
	font-size: 28px;
	color: rgba(255, 255, 255, 0.9);
	margin-bottom: 30px;
	line-height: 1.6;
}

.dialog-button {
	width: 100%;
	height: 65px;
	background: #ffd700;
	border: none;
	border-radius: 8px;
	font-size: 28px;
	font-weight: bold;
	color: #000;
	cursor: pointer;
	transition: background 0.3s;
}

.dialog-button:active {
	background: #ffed4e;
}
</style>